<script>
export default {
  name: "FormValidationMsg",
  inject: [ 'store'],
}
</script>

<template>
  <template v-if="store.Response && store.Response.validation_code == -1">
    <div class="alert alert-warning" 
      v-for="msg in store.Response.validation_errors" 
      :key="msg">{{ msg }}
    </div>
  </template>
</template>